import { api, type ApiResponse } from '@/lib/api';

export interface ConnectViewSourceRequest {
  providerId: string;
  name: string;
  config: Record<string, unknown>;
  credentials: Record<string, unknown>;
}

/**
 * Patch de edição. Chave ausente em `credentials` **mantém** a atual — a API
 * nunca devolve senha, então o formulário não tem como pré-preencher e um campo
 * em branco só pode significar "não mexi nisso".
 */
export interface UpdateViewSourceRequest {
  name?: string;
  config?: Record<string, unknown>;
  credentials?: Record<string, unknown>;
}

export interface ConnectedViewSource {
  id: string;
  status: string;
  /** Chave pública do site — só o tracker próprio devolve. */
  instanceKey?: string;
}

/**
 * Fontes de visitas.
 *
 * ⚠️ Passa pelas rotas de `/views`, e NÃO por `/company-integrations`: aquele
 * módulo é CORE (só super-admin), então o tenant levaria 403. O backend cria a
 * integração pelo service, com a permissão de `dashboards-analytics` — mesmo
 * caminho que canais e bases de dados usam.
 */
export const viewSourcesApi = {
  async connect(data: ConnectViewSourceRequest): Promise<ConnectedViewSource> {
    const response = await api.post<ApiResponse<ConnectedViewSource>>('views/sources', data);
    return response.data.data!;
  },

  async update(integrationId: string, data: UpdateViewSourceRequest): Promise<void> {
    await api.put(`views/sources/${integrationId}`, data);
  },

  async disconnect(integrationId: string): Promise<void> {
    await api.delete(`views/sources/${integrationId}`);
  },

  /** Enfileira uma sincronização imediata. Responde 202 — não espera terminar. */
  async syncNow(integrationId: string): Promise<void> {
    await api.post(`views/sync/${integrationId}`);
  },
};
